import { blobToDataUrl } from './utils'

export const getDoodleFontTtfBuffer = async () => {
  const response = await fetch('/doodle.ttf')
  return await response.arrayBuffer()
}

export const getDoodleFontCss = (() => {
  let fontCss: string
  return async () => {
    if (!fontCss) {
      const response = await fetch('/doodle.woff2')
      const blob = await response.blob()
      const url = await blobToDataUrl(blob)
      fontCss = `@font-face{font-family:dd905323;src:url(${url})}.font-doodle{font-family:dd905323,sans-serif}`
    }
    return fontCss
  }
})()
